import script from "./OttimizzazioneSeoLocarno.vue?vue&type=script&setup=true&lang=js"
export * from "./OttimizzazioneSeoLocarno.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__